// Koltuk (lisans) kararı. AuthContext bunu sarar; saf olması sayesinde
// dört persona tek tek test edilebilir.
export function resolveHasSeat({ user, isSuperAdmin }, code) {
  if (isSuperAdmin) return true;
  // Eski oturumda seats alanı YOKTUR. Burada false dönmek, sürüm geçişinde
  // herkesi bir sonraki token yenilemesine kadar kilitlerdi.
  if (!user?.seats) return true;
  return user.seats.includes(code);
}
